<template lang="pug">
div
  el-form-item(label="多选" )
    el-switch(v-model="multiple2")
  //- el-form-item(label="阶段类型" )
    el-select( v-model="specType" )
      el-option(v-for="item in list" :key="item.value"
        :label="item.label" :value="item.value")
  el-form-item(label="关联更新" )
  field-setting(v-bind="$props", v-model="stageNameKey", label="- 阶段名称")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { STAGE_TYPE } from "./index";
export default {
  mixins: [settingMixin],
  props: {},
  data() {
    return {
      list: [
        {
          label: STAGE_TYPE.USER.LABEL,
          value: STAGE_TYPE.USER.VALUE
        },
        {
          label: STAGE_TYPE.PRJ_ALL.LABEL,
          value: STAGE_TYPE.PRJ_ALL.VALUE
        }
      ]
    };
  },
  computed: {
    ...mapVFOptions("specType", "stageNameKey", "multiple2")
  }
};
</script>
